import PropTypes from 'prop-types';
import { Children } from 'react';
// -*- mode: jsx;-*-
import { Svg } from './Svg.js';
import { KeyboardClickable } from './KeyboardClickable.js';
import { trackShareToolClick, SHARE_TOOLS } from './shareToolUtils.js';


export const MobileShareTray = function (props) {


    function onShareTrayClick(event) {
        event.preventDefault();

        const shareTrayURL = decodeURIComponent(props.getTrackingLink(props.urlToShare, 'sharetray', props.pageName));

        if (navigator.share) {

            navigator.share({
                text: props.projectSummary,
                url: shareTrayURL
            })

        }
        dcAnalytics.trackShareToolClick(props.pageName, props.urlToShare, 'Mobile Share Tray', props.essentialsListShare);
        trackShareToolClick(props.projectId, SHARE_TOOLS.MOBILE_SHARE_TRAY);
    }


    function shareIcon() {
        if (Children.count(props.children) > 0) {
            return null;
        } else {
            return (
                <Svg icon="ss-share" iconFamily="social-circle"/>
            );
        }
    }



    if(!navigator.share){
        return null;
    }else if (props.useSpan){
        return (
            <KeyboardClickable>
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions,jsx-a11y/no-noninteractive-tabindex */}
                <span className={props.className + ' heap-sharetray-share'} aria-label="Share link elsewhere" tabIndex="0" onClick={onShareTrayClick}>
                    {shareIcon()}
                    {props.children}
                </span>
            </KeyboardClickable>
        );
    }else{
        return (
            <a className={props.className + ' heap-sharetray-share'} aria-label="Share link elsewhere" onClick={onShareTrayClick}>
                {shareIcon()}
                {props.children}
            </a>
        );
    }
};

MobileShareTray.propTypes = {
    projectId: PropTypes.number,
    urlToShare: PropTypes.string.isRequired,
    getTrackingLink: PropTypes.func.isRequired,
    pageName: PropTypes.string.isRequired,
    useSpan: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.element,
    projectTitle: PropTypes.string,
    projectSummary: PropTypes.string.isRequired,
    essentialsListShare: PropTypes.bool,
};
